export const fontFamily = 'Fira Sans, sans-serif';

export const weight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
};
